import {
  FETCH_POLLING_FAIL,
  FETCH_POLLING_START,
  FETCH_POLLING_SUCCESS,
  INACTIVE_ALARMS,
  NEW_ACTIVE_ALARM,
  RESET_POLLNG_STATE,
  STOP_POLLING,
  UPDATE_ALARM,
  UPDATE_ALL_ALARMS
} from "../actionTypes/polling";

export const fetchPollingStart = () => ({ type: FETCH_POLLING_START });

export const fetchPollingSuccess = (activeAlarms, systemsStatus) => ({
  type: FETCH_POLLING_SUCCESS,
  payload: { activeAlarms, systemsStatus }
});

export const fetchPollingFail = error => ({
  type: FETCH_POLLING_FAIL,
  payload: { error }
});

export const updateAlarmAction = payload => ({ type: UPDATE_ALARM, payload });
export const updateAllAlarmsAction = payload => ({ type: UPDATE_ALL_ALARMS, payload });
export const stopPolling = () => ({ type: STOP_POLLING });
export const resetPollStateAction = () => ({ type: RESET_POLLNG_STATE });
export const onActiveAlarm = payload => ({ type: NEW_ACTIVE_ALARM, payload });
export const onInActiveAlarms = payload => ({ type: INACTIVE_ALARMS, payload });
